class ToggleClasses {
  constructor(obj) {
    this.toggleClassesArray = obj.toggleClassesArray;
    this.defaultClass = obj.defaultClass;
    this.toggleClassTrigger = obj.toggleClassTrigger;
  }

  init() {
    let activeIndex = this.toggleClassesArray.indexOf(this.defaultClass);

    this.toggleClassTrigger.forEach((trigger) => {
      trigger.addEventListener("click", (event) => {
        // remove class
        document.body.classList.remove(this.toggleClassesArray[activeIndex]);

        // add new class
        if (this.toggleClassesArray[activeIndex + 1] != undefined) {
          document.body.classList.add(this.toggleClassesArray[activeIndex + 1]);

          activeIndex = this.toggleClassesArray.indexOf(
            this.toggleClassesArray[activeIndex + 1]
          );
        } else {
          document.body.classList.add(this.toggleClassesArray[0]);

          activeIndex = 0;
        }
      });
    });
  }
}
